module.exports = __webpack_public_path__ + "assets/img/14_1004.9bef3a27.jpg";